import React from 'react';
import { Box, CircularProgress } from '@mui/material';

/** Shown while a lazy-loaded route chunk is downloading. */
const RouteLoadFallback = () => (
  <Box
    role="status"
    aria-label="Loading page"
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '40vh',
      width: '100%',
    }}
  >
    <CircularProgress size={28} />
  </Box>
);

export default RouteLoadFallback;
